/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs */

const en__field__enum_additionalstudyinterests_study_special_needs_education28 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Special Needs Education`)
};

const de__field__enum_additionalstudyinterests_study_special_needs_education28 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Förderschulen`)
};

/**
* | output |
* | --- |
* | "Special Needs Education" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_special_needs_education28 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Special_Needs_Education28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_special_needs_education28(inputs)
	return de__field__enum_additionalstudyinterests_study_special_needs_education28(inputs)
});
export { _field__enum_additionalstudyinterests_study_special_needs_education28 as "_field__enum_additionalStudyInterests_STUDY_SPECIAL_NEEDS_EDUCATION" }